import { IResourceComponentsProps } from "@pankod/refine-core";
import {
  Edit,
  useForm,
} from "@pankod/refine-antd";
import { IBranchOffices } from "interfaces";
import { BranchOfficesMunicipiesForm } from "components/forms";

export const BranchMunicipalitiesEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IBranchOffices>();
  return (
    <Edit saveButtonProps={saveButtonProps}>
      <BranchOfficesMunicipiesForm
        formProps={formProps}
        queryResult={queryResult}
      />
    </Edit>
  );
};
